import Vue from 'vue';
import VTooltip from 'v-tooltip';
import Vuelidate from 'vuelidate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGtag from 'vue-gtag';
import browserDetect from 'vue-browser-detect-plugin';
import {
	faArrowToTop,
	faAd,
	faAddressCard,
	faAlignLeft,
	faArrowCircleLeft,
	faBalanceScale,
	faBars,
	faBirthdayCake,
	faBug,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDay,
	faCameraRetro,
	faChartBar,
	faChartLine,
	faChevronCircleDown,
	faCloudDownload,
	faCloudUpload as falCloudUpload,
	faCommentAltExclamation,
	faEnvelope as falEnvelope,
	faEnvelopeOpenText,
	faExclamationCircle as falExclamationCircle,
	faExclamationTriangle,
	faEye,
	faExternalLink,
	faFileAlt,
	faFileCertificate,
	faFileImage,
	faFileInvoiceDollar,
	faFilePdf,
	faFilmAlt,
	faFire,
	faFont,
	faHomeHeart,
	faInfinity,
	faMapMarkerSmile,
	faMonitorHeartRate,
	faPalette,
	faPaperPlane,
	faPencilRuler,
	faPercent,
	faPhotoVideo,
	faPlayCircle,
	faPhonePlus,
	faPollH,
	faPowerOff,
	faPresentation,
	faPrint,
	faQuestionCircle,
	faSearch,
	faShareAlt,
	faShareAltSquare,
	faShieldCheck,
	faSign,
	faSquare,
	faStar as falStar,
	faStickyNote as falStickyNote,
	faTachometerFast,
	faTimes,
	faToggleOn,
	faTools,
	faUsdCircle,
	faUser,
	faUserCrown,
	faUserFriends,
	faUserGraduate,
	faUserHardHat,
	faUserTie,
	faUsersClass,
	faUsersMedical,
	faVideo,
} from '@fortawesome/pro-light-svg-icons/';
import {
	faPlus,
	faAt,
	faBell,
	faBellOn,
	faBirthdayCake as farBirthdayCake,
	faCalendar,
	faChartLine as farChartLine,
	faChartPieAlt,
	faCheckCircle,
	faCheckSquare,
	faChevronCircleRight,
	faChevronLeft,
	faChevronRight,
	faClipboard,
	faCloudUpload,
	faCircle as farCircle,
	faCog,
	faEdit,
	faEllipsisH,
	faEnvelope,
	faEnvelopeOpenText as farEnvelopeOpenText,
	faExchange,
	faExclamationCircle,
	faExternalLinkAlt,
	faEye as farEye,
	faFileExport,
	faFileImport,
	faFlame,
	faHistory,
	faHomeHeart as farHomeHeart,
	faHomeLgAlt,
	faItalic,
	faLightbulb,
	faList,
	faListOl,
	faListUl,
	faLocationArrow,
	faMapMarkerSmile as farMapMarkerSmile,
	faMobile,
	faMonitorHeartRate as farMonitorHeartRate,
	faParagraph,
	faPen,
	faPercent as farPercent,
	faPhoneAlt,
	faPlusCircle,
	faRecycle,
	faSearch as farSearch,
	faShieldCheck as farShieldCheck,
	faSlidersH,
	faStar as farStar,
	faStickyNote,
	faStrikethrough,
	faTag,
	faTimesCircle,
	faTimes as farTimes,
	faTrashAlt,
	faUnderline,
	faUndo,
	faUser as farUser,
	faUsers,
	faUserAlt,
} from '@fortawesome/pro-regular-svg-icons';
import {
	faFacebookF,
	faLinkedinIn,
	faInstagram,
	faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
	faAsterisk,
	faBold,
	faCheck,
	faCaretDown,
	faCaretLeft,
	faCaretRight,
	faCircle,
	faShare,
	faUserCog,
} from '@fortawesome/free-solid-svg-icons';
import { faSort, faBellSlash } from '@fortawesome/pro-solid-svg-icons';
import { faSortDown, faSortUp } from '@fortawesome/pro-duotone-svg-icons';

import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';

Vue.config.devtools = globalConfig.devtools.isEnabled;

Vue.use(VTooltip);
Vue.use(browserDetect);
Vue.use(Vuelidate);
Vue.use(
	VueGtag,
	{
		pageTrackerUseFullPath: true,
		config: {
			id: globalConfig.googleAnalytics.key,
		},
	},
	router,
);

library.add(
	faPlus,
	faAd,
	faAddressCard,
	faAlignLeft,
	faArrowCircleLeft,
	faArrowToTop,
	faAsterisk,
	faAt,
	faBalanceScale,
	faBars,
	faBell,
	faBellOn,
	faBellSlash,
	faBirthdayCake,
	farBirthdayCake,
	faBold,
	faBug,
	faCalendar,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDay,
	faCameraRetro,
	faCaretLeft,
	faCaretRight,
	faCaretDown,
	faChartBar,
	faChartPieAlt,
	faChartLine,
	farChartLine,
	faChartPieAlt,
	faCheck,
	faCheckCircle,
	faCheckSquare,
	faChevronCircleDown,
	faChevronCircleRight,
	faChevronLeft,
	faChevronRight,
	faCircle,
	farCircle,
	faClipboard,
	faCloudDownload,
	faCloudUpload,
	falCloudUpload,
	faCog,
	faCommentAltExclamation,
	faEdit,
	faEllipsisH,
	faEnvelope,
	falEnvelope,
	faEnvelopeOpenText,
	farEnvelopeOpenText,
	faEye,
	falExclamationCircle,
	faExclamationCircle,
	faExclamationTriangle,
	faExchange,
	faExternalLink,
	faExternalLinkAlt,
	faEye,
	farEye,
	faFacebookF,
	faFileAlt,
	faFileCertificate,
	faFileExport,
	faFileImage,
	faFileImport,
	faFileInvoiceDollar,
	faFilePdf,
	faFilmAlt,
	faFlame,
	faFont,
	faFire,
	faHistory,
	faHomeHeart,
	farHomeHeart,
	faHomeLgAlt,
	faInfinity,
	faInstagram,
	faItalic,
	faLightbulb,
	faLinkedinIn,
	faList,
	faListOl,
	faListUl,
	faLocationArrow,
	faMapMarkerSmile,
	farMapMarkerSmile,
	faMobile,
	faMonitorHeartRate,
	farMonitorHeartRate,
	faPalette,
	faPaperPlane,
	faParagraph,
	faPen,
	faPencilRuler,
	faPercent,
	farPercent,
	faPhoneAlt,
	faPhonePlus,
	faPhotoVideo,
	faPlayCircle,
	faPlusCircle,
	faPollH,
	faPowerOff,
	faPresentation,
	faPrint,
	faQuestionCircle,
	faRecycle,
	faSearch,
	farSearch,
	faShare,
	faShareAlt,
	faShareAltSquare,
	faShieldCheck,
	farShieldCheck,
	faSign,
	faSlidersH,
	faSort,
	faSortDown,
	faSortUp,
	falStar,
	farStar,
	faStickyNote,
	falStickyNote,
	faStrikethrough,
	faSquare,
	faTachometerFast,
	faTag,
	faTimes,
	farTimes,
	faTimesCircle,
	faToggleOn,
	faTools,
	faTrashAlt,
	faTwitter,
	faUnderline,
	faUndo,
	faUsdCircle,
	faUser,
	farUser,
	faUserAlt,
	faUserCog,
	faUserCrown,
	faUserFriends,
	faUserGraduate,
	faUserHardHat,
	faUserTie,
	faUsers,
	faUsersClass,
	faUsersMedical,
	faVideo,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.prototype.$gtag = function (command, key, options = {}) {
	window.gtag(command, key, options);
};

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
